import axios from 'axios';
import { getJWT } from 'src/helper/localStore/getJWT';
import { IsAuthorized } from 'src/authentication/IsAuthorized';

class ServicePackageService {
  async updateStatus(Id: number, status: string): Promise<void> {
    try {
      await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/air-detail/${Id}`,
        { service_package_status: status },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      );
    } catch (error) {
      IsAuthorized(error);
      throw error;
    }
  }
}

export const servicePackageService = new ServicePackageService();